var Handlebars = require("../../../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"redactTypeTB\" class=\"FV-toolbar FV-noteShapeTB\">\n    <button id=\"rectRedactBtn\" class=\"tb-btn\" data-item=\"rect\" title=\"Rectangle\">\n        <i class=\"icm-frame\"></i>\n    </button>\n    <button id=\"polyRedactBtn\" class=\"tb-btn\" data-item=\"poly\" title=\"Polygon\">\n        <i class=\"icm-polygon\"></i>\n    </button>\n</div>";
},"useData":true});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/views/header/shapeDrawingToolbars/redactionTB/redactionTypeToolbar.hbs
 ** module id = 505
 ** module chunks = 0
 **/